import { createHashHistory } from 'history';
import ReactModal from 'react-modal';
import { Route, Router, Switch } from 'react-router-dom';
import { CompliancePreviewSocialMediaPost } from '../../components/CompliancePreviewSocialMediaPost';
import { ServicesContextProvider } from '../../context';
import { PublicNewsletterPage } from './PublicNewsletterPage';

const AppHashHistory = createHashHistory();

ReactModal.setAppElement('#react-root');

function ViewRouter() {
	return (
		<ServicesContextProvider>
			<Router history={AppHashHistory}>
				<Switch>
					<Route path='/socialMedia/:id?'>
						<CompliancePreviewSocialMediaPost />
					</Route>
					<Route path='/newsletter/:publicShareCode'>
						<PublicNewsletterPage />
					</Route>
				</Switch>
			</Router>
		</ServicesContextProvider>
	);
}

// eslint-disable-next-line import/no-default-export
export default ViewRouter;
